//
// Spin Button

spinButton = {};

spinButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);
  InputHelpers.addRecoveryFlag(button);

  button._flags.credit = {
    balance: 0,
  };
  button._flags.stake = 0;
  button._flags.disabledByPlatform = false;
  button._flags.reelsSpinning = false;

  button.canShow = function () {
    var winlineAnimating = false;
    if (winlineAnimationController !== undefined) {
      winlineAnimating = winlineAnimationController.isAnimating;
    }
    if (button._flags.allowSlamStop) {
      // Show spin button is skip wins button isnt showing, and reels are not spinning (slam stop button)
      return !(
        (winlineAnimating && !this._flags.modal.active) ||
        this._flags.reelsSpinning
      );
    } else {
      // Removed slam stop due GC limitations Sept 2020.
      return !(winlineAnimating && !this._flags.modal.active);
    }
  };

  button.canEnable = function () {
    var canAfford =
      this._flags.credit.balance >= this._flags.stake ||
      gdk.allowSpinIfNotEnoughCredit();
    return (
      !this._flags.inRecovery &&
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      canAfford &&
      !this._flags.disabledByPlatform
    );
  };

  //Updated to support Spin being on release
  //Required by Leander for Lithuania
  var isInvokedOnPressed = function () {
    return !(
      gdk.getEngineSupplier() == "Leander" && gdk.getRegulatedMarket() == "lt"
    );
  };

  var handleInteractionEvent = function () {
    gameController.startGame();
    if (button.soundName !== "") button.playSound();
  };

  button.onPressedCallback = function () {
    if (isInvokedOnPressed()) {
      handleInteractionEvent();
    }
  };

  button.onReleasedCallback = function () {
    if (!isInvokedOnPressed()) {
      handleInteractionEvent();
    }
  };

  button.onCreditChanged = function (creditTask) {
    this._flags.credit.balance = creditTask.data.balance;
  };

  button.changeStake = function (selectedStake) {
    this._flags.stake = selectedStake;
  };

  button.setButtonState = function (data) {
    if (data.buttonName === "Spin") {
      this._flags.disabledByPlatform = !data.enabled;
    }
  };

  button.reelSpinEnded = function () {
    this._flags.reelsSpinning = false;
  };

  button.gameCommittedBase = button.gameCommitted;
  button.gameCommitted = function () {
    this._flags.reelsSpinning = true;
    if (button.gameCommittedBase) {
      button.gameCommittedBase();
    }
  };

  messageBus.subscribe(
    "common:BalanceEvent",
    button.onCreditChanged.bind(button)
  );
  messageBus.subscribe("stake:stakeChanged", button.changeStake.bind(button));
  messageBus.subscribe(
    "platform:setButtonState",
    button.setButtonState.bind(button)
  );
  messageBus.subscribe(
    "spinner:SpinEventDead",
    button.reelSpinEnded.bind(button)
  );
  messageBus.subscribe(
    "common:GameCommitted",
    button.gameCommitted.bind(button)
  );
  messageBus.subscribe("common:AbortGame", button.reelSpinEnded.bind(button));
  messageBus.subscribe(
    "common:GameCompleteEvent",
    button.reelSpinEnded.bind(button)
  );

  return button;
};

spinButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};
spinButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "spinButton",
  spinButton.create,
  spinButton.initialise,
  spinButton.getFilesRequired
);
